const getMealBreakDuration = () => {
  const isFriday = new Date().getDay() === 5;
  return isFriday ? 90 : 60;
};

const getBreakDescription = ({ breakCode, t }) => {
  switch (breakCode) {
    case 'ISTIRAHAT_MAKAN':
      return t('breakDescription.mealBreakText', { duration: getMealBreakDuration() });
    case 'TOILET':
      return t('breakDescription.toiletBreakText');
    case 'SHOLAT':
      return t('breakDescription.prayBreakText');
    case 'BANTU_REKAN':
      return t('breakDescription.helpPartnerBreakText');
    default:
      return t('breakDescription.defaultBreakText');
  }
};

export default getBreakDescription;
